import { CSSProp, styled, theme } from "../../../../../styles/stitches.config"
import { EditIcon } from "../../acquisitionForm/icons/EditIcon"
import { Flex } from "../../../../../components/flex/Flex"

const cellPadding: CSSProp = {
  paddingTop: theme.space.s3_5,
  paddingBottom: theme.space.s3_5,
  paddingRight: "15px",
  paddingLeft: "25px",
}

const cellFonts: CSSProp = {
  lineHeight: "22px",
  fontFamily: "urban_groteskmedium,sans-serif",
  fontWeight: 400,
  wordBreak: "break-word",
  textAlign: "start",
  fontSize: theme.sizes.s3_5,
}

const borderStyle: CSSProp["border"] = "2px solid #f3f8f8"

export const Tr = styled("tr", {
  borderTop: borderStyle,
  display: "inline-table",
  width: "100%",

  variants: {
    borderBottom: {
      true: {
        borderBottom: borderStyle,
      },
    },

    borderless: {
      true: {
        borderTop: "none",
      },
    },
  },

  defaultVariants: {
    borderBottom: false,
    borderless: false,
  },
})

export const Th = styled("th", {
  ...cellFonts,
  ...cellPadding,

  variants: {
    placement: {
      inRow: {
        color: "#527d83",
        fontSize: theme.sizes.s3_5,
        width: 175,
      },
      inHeader: {
        color: theme.colors.primary,
        fontSize: "19px",

        display: "flex",
        justifyContent: "space-between",
      },
    },

    borderRight: {
      true: {
        borderRight: borderStyle,
      },
    },
  },

  defaultVariants: {
    placement: "inRow",
    borderRight: false,
  },
})

export const Td = styled("td", {
  ...cellFonts,
  ...cellPadding,

  color: theme.colors.primary,
  width: 175,

  variants: {
    borderRight: {
      true: {
        borderRight: borderStyle,
      },
    },
  },

  defaultVariants: {
    borderRight: false,
  },
})

export const STable = styled("table", {
  tableLayout: "fixed",
  borderCollapse: "collapse",
  width: "100%",
})

export const EditButton = styled(EditIcon, {
  width: theme.sizes.s4_5,
  height: theme.sizes.s4_5,
  cursor: "pointer",
  color: theme.colors.secondary,

  "@sm": {
    position: "absolute",
    top: "60%",
    right: 0,
    transform: "translateY(-50%)",
  },

  hover: {
    color: theme.colors.primary,
  },

  transition: "color .25s ease-out",
})
export const TableHeader = styled(Flex, {
  justifyContent: "space-between",
  paddingLeft: theme.space.s6,
  paddingRight: theme.space.s6,
  "@sm": {
    paddingLeft: 0,
    paddingRight: 0,
    justifyContent: "center",
    position: "relative",
  },
})

export const StyledTable = styled("table", {
  borderCollapse: "collapse",
  width: "100%",
})

export const StyledTd = styled("td", {
  borderTop: "1px solid",
  borderColor: theme.colors.lines,
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  paddingTop: theme.space.s3_5,
  paddingBottom: theme.space.s3_5,
  paddingLeft: theme.space.s6,
  paddingRight: theme.space.s6,

  "@sm": {
    border: `1.5px solid ${theme.colors.lines}`,
    display: "table-cell",
    width: "50%",
    paddingTop: theme.space.s2,
    paddingBottom: theme.space.s2,
  },
})

export const StyledTr = styled("tr", {
  display: "flex",
  width: "100%",
  flexDirection: "column",

  "@sm": {
    display: "table-row",
  },
})

export const TextName = styled("div", {
  fontSize: theme.fontSizes.small,
  color: theme.colors.primary,
  display: "block",
  lineHeight: "19px",

  "@sm": {
    fontSize: theme.sizes.s2_5,
    display: "table-row",
  },
})
export const TextValue = styled("div", {
  fontSize: theme.fontSizes.small,
  color: theme.colors.texts,
  lineHeight: "19px",
  textAlign: "right",

  "@sm": {
    textAlign: "left",
  },
})
